import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./scss/theme.scss";
import { RouterProvider } from "react-router-dom";
import { Router } from "./components/Router/Router.jsx";
import { ThemeProvider } from "next-themes";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HelmetProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        enableSystem={false}
        disableTransitionOnChange
      >
        <RouterProvider router={Router} />
        <ToastContainer />
      </ThemeProvider>
    </HelmetProvider>
  </StrictMode>
);
